import { Button, Typography } from "@mui/material";
import ColumnContainer from "../../common/ColumnContainer";
import RowContainer from "../../common/RowContainer";
import { FormattedMessage } from "react-intl";

const RegistrationThankYou = ({ handleClose }) => {
  return (
    <ColumnContainer padding={"30px"} style={{ gap: "60px" }}>
      <ColumnContainer>
        <Typography variant="h6" color="var(--text-primary)">
          <FormattedMessage id="registrater.form.success" />
        </Typography>
        <Typography variant="p" color="var(--text-primary)">
          <FormattedMessage id="registrater.form.success.message" />
        </Typography>
      </ColumnContainer>
      <RowContainer center halfGap>
        <Button
          style={{ minWidth: "160px" }}
          variant="contained"
          color="primary"
        >
          <FormattedMessage id="button.backHome" />
        </Button>
        <Button
          style={{ minWidth: "160px" }}
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          <FormattedMessage id="button.close" />
        </Button>
      </RowContainer>
    </ColumnContainer>
  );
};

export default RegistrationThankYou;
